import { useCallback } from 'react';

import { useSWRConfig } from 'swr';

import {
  marketplacesRequestFormActions,
  merchantMarketplacesRequestFormActions,
} from '@entities/marketplace';
import { requestFormStoreActions } from '@entities/merchant';

const useResetApp = () => {
  const { cache } = useSWRConfig();

  const trigger = useCallback(() => {
    // сброс фильтров
    requestFormStoreActions.reset();
    marketplacesRequestFormActions.reset();
    merchantMarketplacesRequestFormActions.reset();

    // сброс кеша swr
    for (const key of cache.keys()) {
      cache.delete(key);
    }
  }, [cache]);

  return { trigger };
};

export default useResetApp;
